const CashFlowReport = () => import('./CashFlow/CashFlowReport.vue')
const AcquisitionReport = () => import('./Acquisition/AcquisitionReport.vue')
const PendingInstallmentsReport = () => import('./PendingInstallments/PendingInstallmentsReport.vue')
const CommissionReport = () => import('./Commission/CommissionReport.vue')
const PayablesReceivablesPivotReport = () => import('./PayablesReceivablesPivot/PayablesReceivablesPivotReport.vue')
const SubscriptionFeesReport = () => import('./SubscriptionFees/SubscriptionFeesReport.vue')
const InstallmentSplitsReport = () => import('./InstallmentSplits/InstallmentSplitsReport.vue')

export default [
  {
    name: 'cash-flow',
    path: 'reports/cash-flow',
    component: CashFlowReport,
    meta: {
      access: ['org.report.finance.cashflow', 'org.report.finance.viewAll', 'org.report.viewAll']
    }
  },
  {
    name: 'acquisition-report',
    path: 'reports/acquisition',
    component: AcquisitionReport,
    meta: {
      access: ['org.report.comercial.acquisition', 'org.report.comercial.viewAll', 'org.report.viewAll']
    }
  },
  {
    name: 'pending-installments',
    path: 'reports/pending-installments',
    component: PendingInstallmentsReport,
    meta: {
      access: ['org.report.finance.pendingInstallments', 'org.report.finance.viewAll', 'org.report.viewAll']
    }
  },
  {
    name: 'commission-report',
    path: 'reports/commission',
    component: CommissionReport,
    meta: {
      access: ['org.report.comercial.commission', 'org.report.comercial.viewAll', 'org.report.viewAll']
    }
  },
  {
    name: 'payables-receivables-pivot',
    path: 'reports/payables-receivables-pivot',
    component: PayablesReceivablesPivotReport,
    meta: {
      access: ['org.report.finance.payablesReceivables', 'org.report.finance.viewAll', 'org.report.viewAll']
    }
  },
  {
    name: 'subscription-fees',
    path: 'reports/subscription-fees',
    component: SubscriptionFeesReport,
    meta: {
      access: ['org.report.finance.subscriptionFees', 'org.report.finance.viewAll', 'org.report.viewAll']
    }
  },
  {
    name: 'installment-splits',
    path: 'reports/installment-splits',
    component: InstallmentSplitsReport,
    meta: {
      access: ['org.report.finance.installmentSplits', 'org.report.finance.viewAll', 'org.report.viewAll']
    }
  }
]
